export const BLOG_POST_LINK =
  "https://community.dune.com/blog/new-features-for-better-collaboration?utm_source=dune";
